import * as Sentry from '@sentry/nextjs'

// https://docs.sentry.io/platforms/javascript/guides/nextjs/usage/

/* eslint-disable no-console */
const log = {
  error: (data) => {
    Sentry.captureException(data)
    console.error(JSON.stringify(data))
  },
  message: (message) => {
    Sentry.captureMessage(message)
    console.error(message)
  },
  warn: (data) => {
    console.warn(JSON.stringify(data))
  },
  info: (data) => {
    console.info(data)
  },

  debug: (data) => {
    console.debug(data)
  },
}

export default log
